import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function SelectController(props) {
  const getId = (item) => item?.id ?? item?.Id ?? item?.ID;
  const getLabel = (item) => {
    if (!item) return '';
    if (item.name) return item.name;
    if (item.Name) return item.Name;
    const first = item.FirstName || '';
    const last = item.LastName || '';
    const combined = `${first} ${last}`.trim();
    return combined || String(getId(item) ?? '');
  };

  const registerName = (props.register || {}).name;
  const resolvedName = props.name ?? registerName ?? '';

  return (
    <Controller
      control={props.control}
      name={resolvedName}
      defaultValue={props.defaultValue ?? null}
      rules={{ required: true }}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          onChange={(event, item) => {
            onChange(item);
            if(props?.salary) {
              props?.salary(item)
            }
          }}
          onBlur={props?.onChangeProp}
          value={value ?? null}
          disabled={Boolean(props.disabled)}
          options={props.options}
          getOptionLabel={(item) => getLabel(item)}
          isOptionEqualToValue={(option, val) => {
            const optionId = getId(option);
            const valueId = getId(val);
            if (valueId === undefined || valueId === null || valueId === '') return true;
            return optionId === valueId;
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              InputLabelProps={{ shrink: true }}
              label={props.placeholder}
              error={props.error ? true : false}
            />
          )}
        />
      )}
    />
    // <Controller
    //   render={({ field: { onChange, value } }) => (
    //     <Autocomplete
    //       onChange={(event, item) => {
    //         onChange(item.id);
    //       }}
    //       value={value}
    //       options={props.options}
    //       getOptionLabel={(item, key) => (item.name ? item.name : '')}
    //       getOptionSelected={(option, value) =>
    //         value === undefined || value === '' || option.id === value.id
    //       }
    //       renderInput={(params) => (
    //         <TextField
    //           {...params}
    //           label={props.placeholder}
    //           error={props.error ? true : false}
    //         />
    //       )}
    //     />
    //   )}
    //   name={props.name}
    //   {...register.register}
    //   control={props.control}
    //   rules={{ required: true }}
    // />
  );
}
